// ==================================================
// NotFound
// ==================================================

import React from 'react';

const NotFound = () => (
  <div>.i le papri na zasti</div>
);

export default NotFound;



// WEBPACK FOOTER //
// ./client/components/not_found.js